import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import scrollIntoView from 'scroll-into-view-if-needed';
@Component({
  selector: 'app-effective-date',
  templateUrl: './effective-date.component.html',
  styleUrls: ['./effective-date.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EffectiveDateComponent implements OnInit {

  constructor(private commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService) { }
  accordion: { title: any, content: any }[] = [];
  ContentList: { title: any, content: any }[] = [];
  pageinitiated: boolean = false;
  ed_header;
  ed_suheader;
  ed_body;

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.commonDataService.archiveContentPage.next(true);
    this.geteffectivedatecomponentlabels();
  }

  geteffectivedatecomponentlabels() {

    this.graphQlService.getEffectivedateComponentHeaderLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.ed_header = labels.filter(x => x.key == "ed_header").map(y => y.value);
        this.ed_suheader = labels.filter(x => x.key == "ed_suheader").map(y => y.value);
        this.ed_body = labels.filter(x => x.key == "ed_body").map(y => y.value);
      }

    });

    this.graphQlService.getEffectivedateComponentLabels().subscribe(data => {
      if (data != "") {
        this.commonDataService.showLoader.next(false);
        this.pageinitiated = true;

        for (let item of data) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(item.content, 'text/html');
          if (item.title.includes("_")) {         

       
            let acctitle = doc.getElementsByClassName('ph b')[2].innerHTML;
            doc.getElementsByClassName('ph b')[2].remove();
            doc.getElementsByClassName('parentlink')[0].remove();
            this.accordion.push({ title: acctitle, content: doc.body.innerHTML });

          } else {

            doc.getElementsByTagName("h3")[0].remove();
            doc.getElementsByClassName('parentlink')[0].remove();
            this.ContentList.push({ title: item.title, content: doc.body.innerHTML });
          }
        }



      }

    });




  }

  foucusaccordian(event) {   
  
      let el = document.getElementById(event.currentTarget.id);

    // el.scrollIntoView();  
    scrollIntoView(el, {
      scrollMode: 'always',
      block: 'start',
      inline: 'start',
      behavior: 'smooth',
      boundary: document.getElementsByTagName('app-main-content')[0]
    })


  }

}
